/**
 * Builds the sandbox URL used for reviewing a migrated Help Center draft.
 *
 * Keep this shared by migration entry points: the legacy help center slug is
 * the review-route identifier, while the migrated hub ARI only determines
 * whether a review action is available.
 */
export const buildMigratedHelpCenterReviewUrl = ({
	baseUrl,
	slug,
}: {
	baseUrl: string;
	slug: string;
}): string => new URL(`/helpcenter/test/${encodeURIComponent(slug)}`, baseUrl).toString();
